import $ from "jquery";

/**
 * Functions to execute on document load.
 */
$(() => {
    // Find the active menu element and "open" the previous nodes
    $(".main-sidebar").find(".active").first().parent("li").first().parents("li").addClass("menu-open");

    $('[type="submit"]').on("click", () => {
        setTimeout(() => ValidationErrorToTooltip(), 100);
    });

    ValidationErrorToTooltip();

    // Highlight input fields on focus
    $(".input-group > input").off("focus");
    $(".input-group > input").on("focus", (event) => {
        $(event.target).parent().prev().css("color", "var(--color-input-border)");
    });
    $(".input-group > input").off("focusout");
    $(".input-group > input").on("focusout", (event) => {
        $(event.target).parent().prev().css("color", "var(--color-label-secondary)");
    });

    // Change label color for select elements when focused
    const targetNodes = document.querySelectorAll("span.select2-container");

    targetNodes.forEach((targetNode) => {
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    const label = targetNode.previousElementSibling?.previousElementSibling;
                    if (label && label.classList.contains("control-label")) {
                        if (
                            targetNode.classList.contains("select2-container--focus") ||
                            targetNode.classList.contains("select2-container--open")
                        ) {
                            (label as HTMLLabelElement).style.color = "rgba(55, 116, 255, 1)";
                        } else {
                            (label as HTMLLabelElement).style.color = ""; // Reset to original color
                        }
                    }
                }
            });
        });

        // Start observing attribute changes on the span
        observer.observe(targetNode, { attributes: true });
    });

    // Show the "Back to top" button only when not at the top
    $(window).on("scroll", () => {
        if ($(window).scrollTop()! > 0) {
            $(".btn-up").fadeIn();
        } else {
            $(".btn-up").fadeOut();
        }
    });

    // Handle the "Back to top" animation / action
    $(".btn-up").on("click", () => {
        $("html, body").animate({ scrollTop: 0 }, 500, "swing");
        return false;
    });

    // Handle the Icon Menu dropdown
    document
        .querySelectorAll<HTMLButtonElement>('button.nav-icon-menu-link[data-bs-toggle="dropdown"]')
        .forEach(button => {
            button.addEventListener('click', () => {
                const id = button.id;
                console.log(id);
                const floating = document.querySelector<HTMLElement>(`[aria-labelledby="${id}"]`);
                if (!floating) return;

                const targetRect = button.getBoundingClientRect();
                const floatRect = floating.getBoundingClientRect();

                let y = targetRect.top + targetRect.height / 2 - floatRect.height / 2;
                y = Math.max(0, y);

                floating.style.top = `${y}px`;
            });
        });

});

/**
 * Bold the last word of the breadcrumb.
 */
export function BoldLastWordOfBreadcrumb(): void {
    $("ul.breadcrumb > li:last-child > span").each((_index, element) => {
        $(element).addClass("fw-bold");
    });
}

/**
 * Apply default permissions to input and textarea elements.
 * @param isReadonly - Set to true to add readonly/disabled.
 * @param isModal - Set to true to apply only to modal elements.
 */
export function InCoreApplyPermissionsDefault(isReadonly: boolean, isModal: boolean = false): void {
    if (!isReadonly) return;

    const container = ".content-wrapper";
    const modal = ".modal-content";

    if (isModal) {
        DisableObjects(modal);
    } else {
        DisableObjects(container);
    }
}

/**
 * Apply permissions to specific containers.
 * @param isReadonly - Set to true to add readonly/disabled.
 * @param classeContainer - Class of the container.
 * @param idContainer - ID of the container.
 */
export function InCoreApplyPermissions(
    isReadonly: boolean,
    classeContainer: string = "",
    idContainer: string = ""
): void {
    if (!isReadonly) return;

    let target = "";

    if (classeContainer && idContainer) {
        target = `#${idContainer}.${classeContainer}`;
    } else if (classeContainer) {
        target = `.${classeContainer}`;
    } else if (idContainer) {
        target = `#${idContainer}`;
    } else {
        InCoreApplyPermissionsDefault(true);
        return;
    }

    DisableObjects(target);
}

/**
 * Disable input, textarea, and other elements in the specified container.
 * @param target - The container selector.
 */
function DisableObjects(target: string): void {
    $(`${target} input, ${target} textarea`).each((_index, element) => {
        $(element).prop("readonly", true);
    });

    // Disable summernote
    $(".note-editable").each((_index, element) => {
        $(element).attr("contenteditable", "false");
    });

    $(`${target} input[type='checkbox'], ${target} input[type='radio'], ${target} select`).each((_index, element) => {
        $(element).prop("disabled", true);
    });
}

/**
 * Handle validation errors for form elements.
 * @param element - The span element containing the error.
 * @param isInnerSpan - Whether the span is nested inside another span.
 * @param isSelect2 - Whether the element is a Select2 dropdown.
 */
function ValidationError(element: HTMLElement, isInnerSpan: boolean, isSelect2: boolean): void {
    const content = $(element).text().trim();

    let input: JQuery<HTMLElement>;
    let textarea: JQuery<HTMLElement>;
    let select: JQuery<HTMLElement>;

    if (isInnerSpan) {
       // flatpickr modale (static): input nel .flatpickr-wrapper, non più sibling diretto dello span.
        input = $(element).parent().siblings("input")
            .add($(element).parent().siblings(".flatpickr-wrapper").find("input:not([type=hidden])"));
        textarea = $(element).parent().siblings("textarea");
        select = isSelect2
            ? $(element).parent().siblings(".select2")
            : $(element).parent().siblings("select");
        $(element).parent().css("display", "none");
    } else {
        // flatpickr modale (static): input nel .flatpickr-wrapper, non più sibling diretto dello span.
        input = $(element).siblings("input")
            .add($(element).siblings(".flatpickr-wrapper").find("input:not([type=hidden])"));
        textarea = $(element).siblings("textarea");
        select = isSelect2 ? $(element).siblings(".select2") : $(element).siblings("select");
        $(element).css("display", "none");
    }

    if (content) {
        input.addClass("is-invalid").attr("title", content);
        textarea.addClass("is-invalid").attr("title", content);
        select.addClass("is-invalid").attr("title", content);
    } else {
        input.removeClass("is-invalid").removeAttr("title");
        textarea.removeClass("is-invalid").removeAttr("title");
        select.removeClass("is-invalid").removeAttr("title");
    }
}

/**
 * Display validation errors as tooltips.
 */
export function ValidationErrorToTooltip(): void {
    $(".w-100 > span:not(.select2), .incore-select > span:not(.select2)").each((_index, element) => {
        ValidationError(element as HTMLElement, false, true);
    });
    $(".form-floating > span, .form-grouping > span, .form-group > span").each((_index, element) => {
        ValidationError(element as HTMLElement, false, false);
    });
    $(".form-floating > span > span, .form-grouping > span > span, .form-group > span > span").each(
        (_index, element) => {
            ValidationError(element as HTMLElement, true, false);
        }
    );
}

export function ShowLoading(divId: string): void {
    const $target = $(`#${divId}`);
    const $overlay = $('#InCoreLoading');

    if ($target.length === 0 || $overlay.length === 0) return;

    $overlay.css({
        width: $target.outerWidth() + 'px',
        height: $target.outerHeight() + 'px',
        top: $target.offset()!.top + 'px',
        left: $target.offset()!.left + 'px',
        display: 'flex'
    });
}

export function HideLoading(): void {
    $('#InCoreLoading').css('display', 'none');
}

export function CloseAllMenus(): void {
    $('.nav-item.menu-is-opening').removeClass('menu-open menu-is-opening');
    $('.nav-treeview').slideUp();
}
